import _ from 'lodash';
const LIMIT = 10;
const MAXLIMIT = 1000;
class BypassCodeController {
    /*@ngInject*/
    constructor(Auth, $state, User, UsersService, DateUtil, RouteService, DataCounter, $translate, $location, $q, Modal, BranchService, HoldLocationService, $scope, LocationService, BypassCodeService, SetupService, RouteStopService, $rootScope) {
        this.BranchService = BranchService;
        this.UsersService = UsersService;
        this.DateUtil = DateUtil;
        this.RouteService = RouteService;
        this.LocationService = LocationService;
        this.BypassCodeService = BypassCodeService;
        this.Modal = Modal;
        this.$translate = $translate;
        this.SetupService = SetupService
        this.$q = $q;
        this.RouteStopService = RouteStopService;
        this.$rootScope = $rootScope;
        this.model = {
            routeId: null,
            branchId: null,
            userId: null,
            locationId: null,
            issues: null,
            comments: null,
            trackingId: null,
            bypassCode: null,
            supvApproveId: 0,
            canNotScanLocation: false
        };
        this.userLists = [];
        this.routeLists = [];
        this.branches = [];
        this.allUsers = [];
        this.allBypassCodeData = [];
        this.date = new Date();

        this.issues = [
            {
                lable: $translate.instant('branch_mgmt.bypass_code.locationdp'),
                value: "cant_scan_location"
            },
            {
                lable: $translate.instant('branch_mgmt.bypass_code.truckdp'),
                value: "cant_load_truck"
            }
        ]

        this.locationLists = [];
        // Convert exponents to number
        Number.prototype.noExponents = function () {
            var data = String(this).split(/[eE]/);
            if (data.length == 1) return data[0];

            var z = '', sign = this < 0 ? '-' : '',
                str = data[0].replace('.', ''),
                mag = Number(data[1]) + 1;

            if (mag < 0) {
                z = sign + '0.';
                while (mag++) z += '0';
                return z + str.replace(/^\-/, '');
            }
            mag -= str.length;
            while (mag--) z += '0';
            return str + z;
        }
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/4P-bypass-code');
    }

    loadPermission() {
        this.acl = {};
        this.hasACL = {};

        [].forEach((permissionKey) => {
            this.acl[permissionKey] = this.User.getACL(permissionKey)

            this.hasACL[permissionKey] = {};

            this.acl[permissionKey].forEach((permission) => {
                this.hasACL[permissionKey][permission] = true;
            });
        });
    }

    $onInit() {
        this.loading = true;
        this.loadPermission();

        this.$q.all([
            this.BranchService.all(null, 0, MAXLIMIT),
        ])
            .then((data) => {
                const branches = data[0].results;
                this.branches = branches;
                this.getAllBypassCode();
            });
    }

    getAllLocation(searchKey, offset) {
        let loadLocationDatas = '';

        if (searchKey) loadLocationDatas = this.loadLocationDataWithSearch(searchKey);
        else loadLocationDatas = this.loadLocationData();

        if (document.getElementById("select").selectedIndex == 1) {
            this.LocationService.getAllLocation(loadLocationDatas, offset, LIMIT)
                .then((data) => {

                    if (offset === 0) {
                        this.totalRecords = data.total;
                        this.locationLists = this.mappingLocationDatas(data.results);
                    }
                    else {
                        const locations = this.mappingLocationDatas(data.results);
                        this.locationLists = this.locationLists.concat(locations);
                    }
                })
        } else {
            this.getRouteStopData(searchKey, offset)
        }
    }

    getRouteStopData(searchKey, offset) {
        let loadRouteStops = '';

        if (searchKey) loadRouteStops = this.loadRouteStopWithSearch(searchKey);
        else loadRouteStops = this.loadRouteStopData();

        this.RouteStopService.all(loadRouteStops, offset, LIMIT)
            .then((data) => {
                if (offset === 0) {
                    this.totalRecords = data.total;
                    this.locationLists = this.mappingRouteStops(data.results);
                }
                else {
                    const locations = this.mappingRouteStops(data.results);
                    this.locationLists = this.locationLists.concat(locations);
                }
            })
    }

    getAllUsers(searchKey, offset) {
        let loadUserDatas = '';
        if (searchKey)
            loadUserDatas = this.loadUserDataWithSearch(searchKey);
        else
            loadUserDatas = this.loadUserData();

        this.UsersService.all(loadUserDatas, offset, LIMIT)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.totalUserRecord = data.total;
                    this.userLists = this.mappingUserDatas(data.results);
                } else {
                    const users = this.mappingUserDatas(data.results);
                    this.userLists = this.userLists.concat(users)
                }
            })
    }

    branchChanged() {
        this.model.routeId = null;
        this.model.locationId = null;
        this.model.userId = null;
        this.locations = [];
        this.locationLists = [];
        this.totalRecords = 0;
        this.SetupService.get(this.model.branchId)
            .then((setup) => {
                const date = this.DateUtil.convertToDate(setup.currentVaultDate);
                const vaultDate = moment(date).format('YYYY-MM-DD');
                this.vaultDate = vaultDate;
                this.isCoinCheckOut = setup.coinCheckOut;
                this.getRouteData(vaultDate);
                this.locationChanged();
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal('error.' + err.data.message);
                }
            });
        this.getUserData();
    }

    // load locationType == TRUCK data based on BranchID
    loadRouteStopData() {
        const searchObj = {
            queryJSON: {
                rules: [{
                    field: "routeId",
                    condition: "=",
                    data: this.model.routeId.Value
                },
                {
                    field: "routeDate",
                    condition: "=",
                    data: this.vaultDate
                }
                ],
                operator: "AND"
            }
        }
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    // load locationType == TRUCK data based on BranchID
    loadRouteStopWithSearch(searchKey) {
        const searchObj = {
            queryJSON: {
                rules: [{
                    field: "routeId",
                    condition: "=",
                    data: this.model.routeId.Value
                },
                {
                    field: "routeDate",
                    condition: "=",
                    data: this.vaultDate
                },
                {
                    group: {
                        rules: [{
                            field: "locationId",
                            condition: "like",
                            data: "%" + searchKey + "%"
                        },
                            // {
                            //     field: "name",
                            //     condition: "like",
                            //     data: "%" + searchKey + "%"
                            // }
                        ],
                        operator: "OR"
                    }
                }
                ],
                operator: "AND"
            }
        }
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    // load locationType == REGULAR, NO_SHIP_NO_GO, ATM, BANK, ON_CALL data based on BranchID
    loadLocationData() {
        const searchObj = {
            queryJSON: {
                rules: [{
                    field: "branchId",
                    condition: "=",
                    data: this.model.branchId
                },
                {
                    group: {
                        rules: [{
                            field: "locationType",
                            condition: "=",
                            data: "REGULAR"
                        },
                        {
                            field: "locationType",
                            condition: "=",
                            data: "NO_SHIP_NO_GO"
                        },
                        {
                            field: "locationType",
                            condition: "=",
                            data: "ATM"
                        },
                        {
                            field: "locationType",
                            condition: "=",
                            data: "BANK"
                        },
                        {
                            field: "locationType",
                            condition: "=",
                            data: "ON_CALL"
                        }
                        ],
                        operator: "OR"
                    }
                }
                ],
                operator: "AND"
            }
        }
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    // load locationType == REGULAR, NO_SHIP_NO_GO, ATM, BANK, ON_CALL data based on BranchID With Search value
    loadLocationDataWithSearch(searchKey) {
        const searchObj = {
            queryJSON: {
                rules: [{
                    field: "branchId",
                    condition: "=",
                    data: this.model.branchId
                },
                {
                    group: {
                        rules: [{
                            field: "locationType",
                            condition: "=",
                            data: "REGULAR"
                        },
                        {
                            field: "locationType",
                            condition: "=",
                            data: "NO_SHIP_NO_GO"
                        },
                        {
                            field: "locationType",
                            condition: "=",
                            data: "ATM"
                        },
                        {
                            field: "locationType",
                            condition: "=",
                            data: "BANK"
                        },
                        {
                            field: "locationType",
                            condition: "=",
                            data: "ON_CALL"
                        }
                        ],
                        operator: "OR"
                    }
                },
                {
                    group: {
                        rules: [{
                            field: "id",
                            condition: "like",
                            data: "%" + searchKey + "%"
                        },
                        {
                            field: "name",
                            condition: "like",
                            data: "%" + searchKey + "%"
                        }
                        ],
                        operator: "OR"
                    }
                }
                ],
                operator: "AND"
            }
        }
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    // load data based on BranchID
    loadUserData() {
        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    },
                    {
                        group: {
                            rules: [
                                {
                                    field: 'downloadToHHT',
                                    condition: '=',
                                    data: true
                                },
                                {
                                    field: 'email',
                                    condition: '!=',
                                    data: null
                                },
                                {
                                    field: 'supervisor',
                                    condition: '=',
                                    data: true
                                },
                                {
                                    field: 'serviceUser',
                                    condition: '=',
                                    data: true
                                },
                                {
                                    field: 'customerUser',
                                    condition: '=',
                                    data: true
                                }
                            ],
                            operator: "OR"
                        }
                    },
                ],
                operator: "AND"
            }
        }
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    // load data based on BranchID With search value
    loadUserDataWithSearch(searchKey) {
        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    },
                    {
                        group: {
                            rules: [
                                {
                                    field: 'downloadToHHT',
                                    condition: '=',
                                    data: true
                                },
                                {
                                    field: 'email',
                                    condition: '!=',
                                    data: null
                                },
                                {
                                    field: 'supervisor',
                                    condition: '=',
                                    data: true
                                },
                                {
                                    field: 'serviceUser',
                                    condition: '=',
                                    data: true
                                },
                                {
                                    field: 'customerUser',
                                    condition: '=',
                                    data: true
                                }
                            ],
                            operator: "OR"
                        }
                    },
                    {
                        group: {
                            rules: [
                                {
                                    field: "id",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                },
                                {
                                    field: "firstName",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                },
                                {
                                    field: "lastName",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                }
                            ],
                            operator: "OR"
                        }
                    }
                ],
                operator: "AND"
            }
        }
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    // change location type based on issues
    locationChanged() {
        const loadLocationDatas = this.loadLocationData();

        if (document.getElementById("select").selectedIndex == 1) {
            this.LocationService.getAllLocation(loadLocationDatas, 0, LIMIT)
                .then((data) => {
                    this.model.canNotScanLocation = true;
                    this.locationTypeData = data.results;
                    this.totalRecords = data.total;
                    this.locationLists = this.mappingLocationDatas(data.results);
                })
        }
    }

    getRouteStops() {
        this.model.locationId = "";
        if (document.getElementById("select").selectedIndex == 2 && this.model.routeId) {
            const loadRouteStops = this.loadRouteStopData();
            this.RouteStopService.all(loadRouteStops, 0, LIMIT)
                .then((data) => {
                    this.model.canNotScanLocation = false;
                    this.locationTypeData = data.results;
                    this.totalRecords = data.total;
                    this.locationLists = this.mappingRouteStops(data.results);
                })
        }
    }

    mappingLocationDatas(locations) {
        return locations.map((location) => {
            return {
                Key: location.id + " | " + location.name,
                Value: location.id
            }
        });
    }

    loadData() {
        if (this.model.branchId !== null) {
            this.model.locationId = "";
            this.locationChanged();
            this.getRouteStops();
        }
    }

    mappingUserDatas(users) {
        return users.map((user) => {
            return {
                Key: user.id + " | " + user.firstName + " " + user.lastName,
                Value: user.id
            }
        });
    }

    getUserData() {
        this.UsersService.all(this.loadUserData(), 0, LIMIT)
            .then((data) => {
                this.totalUserRecord = data.total;
                this.userLists = this.mappingUserDatas(data.results);
            })
    }

    mappingRouteDatas(routes) {
        return routes.map((route) => {
            return {
                Key: route.routeId + " | " + route.routeName,
                Value: route.routeId
            }
        });
    }

    getRouteData(vaultDate) {
        this.BranchService.getReleaseRoutes(this.model.branchId, vaultDate, this.isCoinCheckOut)
            .then((res) => {
                this.routeLists = this.mappingRouteDatas(res);
                this.totalRouteRecords = res.length;
            })
            .catch((err) => {
                if (!err.data.success) {
                    this.Modal.errorModal(err.data.message);
                }
            });
    }

    readMul(mul) {
        return (typeof mul !== 'number' || isNaN(mul))
            ? 1 : mul;
    }

    readDate(date) {
        return (typeof date !== 'object' ||
            false === (date instanceof Date)) ?
            new Date() : date;
    }
    pad(s, p, r) {
        if (!s || !p || p.length <= s.length) return s;
        return r ? (s + p).substr(0, p.length) : (p + s).substr(-p.length);
    }

    getDate(date) {
        date = this.readDate(date);
        let
            year = String(date.getFullYear()).substr(-2), // use last 2 digits of year
            day = this.pad(date.getDate().toString(), '00'), // left zero padded date
            month = (date.getMonth() + 1).toString(); // month of year as string (date.getMonth is zero indexed)

        return parseInt(month + day + year);
    }

    getDayOfMonth(date, mul) {
        return this.readDate(date).getDate() * this.readMul(mul);
    }

    encode(numericId, date, mul) {
        // console.log("encode", numericId, date, mul)
        return Number(numericId) + this.getDate(date) - this.getDayOfMonth(date, mul);
    }

    decode(bypassCode, date, mul) {
        // console.log("decode", bypassCode, date, mul)
        return Number(bypassCode) - this.getDate(date) + this.getDayOfMonth(date, mul);
    }

    confirmSupervisor() {
        if (this.isLoading) return;
        this.isLoading = true;
        this.Modal.confirmSupervisor('generate-bypass-code', null, ({ modal, supId }) => {
            this.model.supvApproveId = supId;
            this.generateBypassCode();
            modal.close();
        }, ({ modal }) => {
            if (modal) modal.close();
            this.isLoading = false;
        })
    }

    generateBypassCode() {
        this.loading = true;
        // console.log(this.model.locationId.Value, this.vaultDate, this.model.canNotScanLocation == true ? 7 : 8)
        var seedVal = this.model.locationId ? this.model.locationId.Value : parseInt(this.model.trackingId, 36);
        var bypassCode = this.encode(seedVal, new Date(this.vaultDate), this.model.canNotScanLocation == true ? 7 : 8)
        this.model.bypassCode = bypassCode.noExponents();

        this.model.type = this.model.issues;
        this.model.locationId = this.model.locationId.Value;
        this.model.userId = this.model.userId.Value;
        this.model.routeId = this.model.routeId.Value;
        this.BypassCodeService.create(this.model)
            .then((data) => {
                this.isLoading = false;
                this.bypassCode = data.bypassCode;
                this.getAllBypassCode();
                this.reset();
            })
            .catch((err) => {
                this.isLoading = false;
                this.loading = false
                const errorCode = err && err.data && err.data.message;
                if (errorCode) {
                    if (err.data.errors[0].path === 'bypasscode_tracking_id_unique') {
                        this.bypassCodeThrowError = this.$translate.instant('error.trackingIdUnique');
                    } else {
                        this.bypassCodeThrowError = this.$translate.instant('error.bypassCodeNotGenerate');
                    }
                    this.Modal.errorModal(this.bypassCodeThrowError);
                }
                else {
                    console.log(err);
                }
            })
    }

    getAllBypassCode() {
        this.BypassCodeService.all(null, 0, 100)
            .then((allBypassCode) => {
                this.allBypassCodeData = allBypassCode.results;
                this.loading = false;
            })
    }

    reset() {
        this.model.routeId = null;
        this.model.userId = null;
        this.model.locationId = null;
        this.model.comments = null;
        this.model.trackingId = null;
        this.model.bypassCode = null;
        this.model.supvApproveId = 0;
        this.model.issues = null;
        this.locationLists = [];
        this.totalRecords = 0;
    }

    mappingRouteStops(data) {
        return data.map((d) => {
            return {
                Key: d.location.id + " | " + d.location.name,
                Value: d.location.id
            }
        });
    }

    translateIssue(message) {
        if (!message || message === 'Location') return;
        return this.$translate.instant(`branch_mgmt.tnt_bypass_code.${message}`);
    }
}

export default BypassCodeController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/bypass_code/bypass_code.controller.js